import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {ScoresMobileHeaderDaterPlaceholder} from "../../../../core/components/scores-placeholders/placeholder/scores.mobile-header-dater.placeholder";

export class ScoresListWidgetMobileHeaderPlaceholderComponentProps extends BaseProps {}

export const ScoresListHeaderModuleMobilePlaceholder = (props: ScoresListWidgetMobileHeaderPlaceholderComponentProps) => {
  return (
    <div className={'scores-list-header-module-mobile-placeholder-container'}>
      <ScoresMobileHeaderDaterPlaceholder {...props}/>
    </div>
  )
}